import{a as p}from"./chunk-IBACENKX.js";import{a as n}from"./chunk-A357F5TT.js";import{a as i,z as r}from"./chunk-326XWAT2.js";import{m as o}from"./chunk-HBP5N4FR.js";o();r();p();var A=t=>n({apiEndpoint:t?`${i}/${t}?withGuardianInfo=true`:null});export{A as a};
//# sourceMappingURL=chunk-3OG6C3AH.js.map
